<template>
  <v-row class="pt-2 pb-4">
    <v-col class="pa-0 tag-sequence" v-if="docPartTag.active">
      <div>
        {{ docPartTag.sequence }}
      </div>
    </v-col>
    <v-col class="pa-0">
      <div class="tag-value" v-if="docPartTag.active">
        {{ docPartTag.value }}
        <v-tooltip top v-if="docPartTag.description">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
          </template>
          <div style="max-width: 300px;">{{ docPartTag.description }}</div>
        </v-tooltip>
      </div>
      <div v-if="docPartTag.active && docPartTag.rating_description" class="tag-description">{{ docPartTag.rating_description }}</div>
      <div class="tag-issues" v-if="highlightChanges && (docPartTag.errors?.length || docPartTag.warnings?.length || docPartTag.successes?.length)">
        <span class="tag-error" v-for="(e, ei) in docPartTag.errors" :key="'e' + ei">
          <v-icon>mdi-alert-circle-outline</v-icon>{{ e }}
        </span>
        <span class="tag-warning" v-for="(e, ei) in docPartTag.warnings" :key="'e' + ei">
          <v-icon>mdi-alert</v-icon>{{ e }}
        </span>
        <span class="tag-success" v-for="(e, ei) in docPartTag.successes" :key="'e' + ei">
          <v-icon>mdi-alert-circle-outline</v-icon>{{ e }}
        </span>
      </div>
      <div v-if="docPartTag.active">
        <v-chip v-if="docPartTag.rating_name" small>
          {{ docPartTag.rating_name }}
        </v-chip>
        <v-chip v-if="docPartTag.grading_name" small>
          {{ docPartTag.grading_name }}
        </v-chip>
        <v-chip v-if="docPartTag.classifiers && !Array.isArray(docPartTag.classifiers)" small>
          {{ docPartTag.classifiers }}
        </v-chip>
        <template v-if="Array.isArray(docPartTag.classifiers)">
          <v-chip v-for="c in docPartTag.classifiers.filter(c => c.value)" :key="c.tag_classifier_id" small>
            {{ c.value }}
          </v-chip>
        </template>
      </div>
    </v-col>
  </v-row>
</template>
  
<script>
// import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
// import utils from "@/common/utils.js";
import { mapState } from "vuex";

export default {
  name: "DocumentVersionCompareTagSummary",
  components: {
    // ResponseHandler,
  },
  props: {
    docPartTag: Object,
    highlightChanges: { type: Boolean, default: true },
  },
  data: function () {
    return {};
  },
  watch: {},
  computed: {
    ...mapState({
      tagTypes: (state) => state.hierarchies.tagTypes,
      tagClassifierTypes: (state) => state.hierarchies.tagClassifierTypes,
      tagPermissions: (state) => state.hierarchies.tagPermissions,
    }),
  },
  created() {},
  methods: {},
};
</script>
<style scoped lang="scss">
  .tag-sequence {
    max-width: 30px;
  }
  .tag-value,
  .tag-sequence {
    font-weight: bold;
    font-size: 14px;
  }
  .tag-description {
    font-size: 12px;
    font-weight: 200;
  }
  .tag-issues {
    padding: 5px 0;
    > span {
      padding: 0 5px;
      .v-icon {
        margin-right: 5px;
      }
    }
  }
  .v-chip {
    border-radius: 5px !important;
    font-weight: bold;
    margin-right: 10px;
  }

  .v-application.theme--light {
    .tag-error {
      background-color: #F6D5D4;
      color: #F4675D;
      .v-icon {
        color: #F4675D;
      }
    }
    .tag-warning {
      background-color: #FFF5CC;
      .v-icon {
        color: #FFCB00;
      }
    }
    .tag-success {
      background-color: #e4f6df;
      .v-icon {
        color: #78f148;
      }
    }
  }

  .v-application.theme--dark {
    .tag-error {
      background-color: #a9231e;
      color: #ebd5d3;
      .v-icon {
        color: #ebd5d3;
      }
    }
    .tag-warning {
      background-color: #635008;
      color: #d5cfb9;
      .v-icon {
        color: #d5cfb9;
      }
    }
    .tag-success {
      background-color: #72da55;
      .v-icon {
        color: #78f148;
      }
    }
  }
</style>
  